import { Grid, Typography } from '@mui/material';
import React from 'react';
import MarkdownRenderer from '../../../components/MarkdownRenderer/index';

export function getRecipeDetails(content) {
  const title = content.fields?.recipeName?.replace(/recipe/i, '').trim() || 'Missing recipe title';
  const body = content.fields?.recipebody || 'Missing recipe body';
  return {
    title,
    Body: () => (
      <>
        <Grid
          maxWidth="800px"
          margin="auto"
        >
          <Typography variant="h3">{title}</Typography>
        </Grid>
        <Grid
          maxWidth="800px"
          margin="auto"
        >
          <MarkdownRenderer markdownText={body} />
        </Grid>
      </>
    ),
  };
}
